<template>
    <div class="teachertips">
        <loading v-if="!teachertips"></loading>

        <div v-if="teachertips">
            <h1>Tips</h1>
            <div class="teachertips-content" v-html="teachertips.content"></div>
        </div>
    </div>
</template>


<script>
import api from 'js/api/resources'
import notify from 'js/components/notifications/notificationsMixin'
import { getCurrentAssignment } from 'js/vuex/getters'
import { transform } from 'js/vuex/helpers'
import track from 'js/helpers/analytics';
import autoGlossary from 'js/components/elements/autoGlossaryMixin'

import Loading from 'js/components/elements/Loading.vue'


export default {
    props: {
        step: {}
    },
    mixins: [ notify, autoGlossary ],
    components: { Loading },
    vuex: {
        getters: {
            getCurrentAssignment
        },
        actions: {
            addTeachertips: ({dispatch}, teachertips) => dispatch('ADD_TEACHERTIPS', teachertips),
        }
    },
    mounted: function() {

        if ( this.teachertips == null ) {

            api.getTeachertips(this.step.id)
                .then( response => transform(response.body))
                .then( data => {
                    this.addTeachertips(data.teachertips)
                })
                .catch( e  => {
                    track.exception('Can\'t find teacher tips', e, { step: this.step.id })
                    this.$warn('Kan tips niet vinden.')
                    this.close()
                })

        }

    },
    methods: {
        close: function() {
            this.$emit('close')
        }
    },
    computed: {
        teachertips: function() {
            return this.$store.state.steps.teachertips[this.step.id]
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Teachertips.vue?2f0ae43f